export default __webpack_public_path__ + "static/media/sportsbra-medium-back-toosmall.96b0e779.jpg";